import React,{useEffect, useState} from 'react'
import Development from '../development-card'
import Loading from '../Loading'
import { connect } from 'react-redux'
import {getDevelopmentsFilterAction, updateFiltersDevelopment} from '../../redux/developmentsDucks'
import { getCustomTags, getReverseOrder, getOrderByDate } from '../../helpers/helper.developments'
import CardDevelopmentGroup from '../cardDevelopmentGroup'

const Developments = ({developmentsFilters,developments,loading,api_key,dispatch}) => {

    const [filter,setFilter] = useState(0)
    const [buttons,setButtos] = useState([
        {
            name:"VER TODOS",
            value:0,
        },
        {
            name:"EN POZO",
            value:3,
        },
        {
            name:"EN CONSTRUCCIÓN",
            value:4
        },
        {
            name:"TERMINADOS",
            value:6
        }

    ])

    useEffect(() => {
        if(api_key){	
            dispatch(updateFiltersDevelopment(filter))
            dispatch(getDevelopmentsFilterAction()) // Get all developments
        }
    },[filter,api_key])

    const checkStatusInArray = (id) => {
        if(developments?.data?.objects.find(element => element.construction_status === id)){
            return true
        }
        return false;
    }

    const getSingularDevelopments = (developments,group) => { //Devuelve los emprendimientos sin la etiqueta que agrupa
        const developments_singular = []
        for (const development of developments) {
            if(development.custom_tags.find(element => element.group_name?.toLowerCase() === group?.toLowerCase())){
            }
            else{
                developments_singular.push(development)
            }
        }
        return developments_singular;
    }

    return developmentsFilters.data && !loading ? (
        <section id="featured-devs" class={"pt-lg-5 " }>
            {
                <>
                <div class={"container-fluid " + (getCustomTags(developments,"Grupo-emprendimiento").length === 0 && 'd-none')}>
                    <div class={"row no-gutters mt-5 mt-lg-1 mb-lg-4 " + (getCustomTags(developments,"Grupo-emprendimiento").length === 0 && 'd-none')} >
                        {
                                getCustomTags(developments,"Grupo-emprendimiento").map((tag,index) => (
                                    // <div className="col-lg-4">
                                    <div className={(getCustomTags(developments,"Grupo-emprendimiento").length === 1 
                                        ? 'col-lg-12 ' //Si es uno solo, 100%
                                        : ((getCustomTags(developments,"Grupo-emprendimiento").length < 9 && index === 0 && getCustomTags(developments,"Grupo-emprendimiento").length % 2 === 1)  
                                            ? 'col-lg-12 ' // Si impares menor a 9, el primero 100%
                                            : (getCustomTags(developments,"Grupo-emprendimiento").length < 9) 
                                                ? 'col-lg-6' //Si menores a 9, 50%
                                                :  (getCustomTags(developments,"Grupo-emprendimiento").length >= 9 && getCustomTags(developments,"Grupo-emprendimiento").length % 3 === 1 && index === 0)
                                                    ? 'col-lg-12' // Si es mayor o igual a 9, y sobra 1, 100% el primero
                                                    : (getCustomTags(developments,"Grupo-emprendimiento").length >= 9 && getCustomTags(developments,"Grupo-emprendimiento").length % 3 === 2 && (index === 0 || index === 1)
                                                        ? 'col-lg-6' // Si son 9 o mas, y sobran 2, los primeros 2, 50%  
                                                        : 'col-lg-4' // Si son 9 o mas, 33,3%
                                        )))}>
                                        <CardDevelopmentGroup developments={developments.data.objects} tag={tag} />
                                    </div>
                                ))
                        }
                    </div>
                </div>
                <div className="container-fluid">
                    <div class={"row no-gutters mt-5 pt-lg-3 mb-lg-4 " + (getCustomTags(developments,"Grupo-emprendimiento").length > 0 ? 'mt-lg-5' : 'mt-lg-0')}>
                        <div className={"col-12 mb-lg-4 " + (getCustomTags(developments,"Grupo-emprendimiento").length === 0 && 'd-none')}>
                            <h1>Conocé nuestros emprendimientos</h1>
                        </div>
                        {getSingularDevelopments(getOrderByDate(developmentsFilters.data.objects)).length > 0 
                            ?   getSingularDevelopments(getOrderByDate(developmentsFilters.data.objects),'grupo-emprendimiento').map((development,index) => (
                                    <div class={index + " mb-3 mb-lg-4 pb-lg-2 px-lg-3 " + 
                                        (getSingularDevelopments(getOrderByDate(developmentsFilters.data.objects)).length === 1 
                                        ? 'col-lg-12 ' //Si es uno solo, 100%
                                        : ((getSingularDevelopments(getOrderByDate(developmentsFilters.data.objects)).length < 9 && index === 0 && getSingularDevelopments(getOrderByDate(developmentsFilters.data.objects)).length % 2 === 1)  
                                            ? 'col-lg-12 ' // Si impares menor a 9, el primero 100%
                                            : (getSingularDevelopments(getOrderByDate(developmentsFilters.data.objects)).length < 9) 
                                                ? 'col-lg-6' //Si menores a 9, 50%
                                                :  (getSingularDevelopments(getOrderByDate(developmentsFilters.data.objects)).length >= 9 && getSingularDevelopments(getOrderByDate(developmentsFilters.data.objects)).length % 3 === 1 && index === 0)
                                                    ? 'col-lg-12' // Si es mayor o igual a 9, y sobra 1, 100% el primero
                                                    : (getSingularDevelopments(getOrderByDate(developmentsFilters.data.objects)).length >= 9 && getSingularDevelopments(getOrderByDate(developmentsFilters.data.objects)).length % 3 === 2 && (index === 0 || index === 1)
                                                        ? 'col-lg-6' // Si son 9 o mas, y sobran 2, los primeros 2, 50%  
                                                        : 'col-lg-4' // Si son 9 o mas, 33,3%
                                        )))}>
                                        <Development key={index} development={development} />
                                    </div>                  
                                ))
                            :   <h4 className="text-center">No hay emprendimientos {filter !== 0 && buttons.find(element => element.value === filter).name?.toLowerCase()}</h4>}
                    </div>
                </div>
            </>
            }
        </section> 
    )   :<Loading />
}
export default connect(state => ({
    developmentsFilters: state.developments.developmentsFilters,
    loading: state.developments.loading,
    developments:state.developments.developments,
    api_key: state.settings.keys.tokko

}),null)(Developments);